var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalSucceeded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170 100.5C170 138.332 138.66 169 100 169C61.3401 169 30 138.332 30 100.5C30 62.6685 61.3401 32 100 32C138.66 32 170 62.6685 170 100.5ZM40.6116 100.5C40.6116 132.596 67.2007 158.616 100 158.616C132.799 158.616 159.388 132.596 159.388 100.5C159.388 68.4035 132.799 42.3842 100 42.3842C67.2007 42.3842 40.6116 68.4035 40.6116 100.5ZM70.5452 102.821C72.1116 101.263 74.6443 101.27 76.2021 102.836L91.4934 118.212L124.257 85.267C125.815 83.7006 128.348 83.6936 129.914 85.2514L130.623 85.9566C132.19 87.5144 132.197 90.047 130.639 91.6134L95.87 126.574C95.6849 126.928 95.4432 127.26 95.1451 127.556L94.4361 128.261C92.8697 129.819 90.337 129.812 88.7792 128.246L69.8206 109.183C68.2628 107.616 68.2698 105.084 69.8362 103.526L70.5452 102.821Z",
    fill: "#00D44F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSucceeded);
export default __webpack_public_path__ + "static/media/modal-succeeded.0fff8dd500f37ff5dba99c691d0a1999.svg";
export { ForwardRef as ReactComponent };